import { FC } from 'react';

type Props = {
	className?: string;
};

const Analytics_01_IconSolid: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='#2B2B2B'
			stroke='none'
			className={className}>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M14.1462 2.14095C13.0977 1.99998 11.7547 1.99999 10.0448 2H9.95552C8.24568 1.99999 6.90269 1.99998 5.85414 2.14095C4.77966 2.28541 3.92715 2.5875 3.25732 3.25732C2.5875 3.92715 2.28541 4.77966 2.14095 5.85414C1.99998 6.90269 1.99999 8.24568 2 9.95552V10.0448C1.99999 11.7547 1.99998 13.0977 2.14095 14.1462C2.28541 15.2206 2.5875 16.0732 3.25732 16.743C3.92715 17.4128 4.77966 17.7149 5.85414 17.8594C6.90269 18.0003 8.24567 18.0003 9.95552 18.0003H10.0448C11.7547 18.0003 13.0977 18.0003 14.1462 17.8594C15.2206 17.7149 16.0732 17.4128 16.743 16.743C17.4128 16.0732 17.7149 15.2206 17.8594 14.1462C18.0003 13.0977 18.0003 11.7547 18.0003 10.0448V9.95552C18.0003 8.24567 18.0003 6.90269 17.8594 5.85414C17.7149 4.77966 17.4128 3.92715 16.743 3.25732C16.0732 2.5875 15.2206 2.28541 14.1462 2.14095ZM6.68302 10.7807C6.68302 10.4574 6.42094 10.1953 6.09764 10.1953C5.77435 10.1953 5.51227 10.4574 5.51227 10.7807V13.9027C5.51227 14.226 5.77435 14.4881 6.09764 14.4881C6.42094 14.4881 6.68302 14.226 6.68302 13.9027V10.7807ZM10.0002 5.51227C10.3234 5.51227 10.5855 5.77435 10.5855 6.09764V13.9027C10.5855 14.226 10.3234 14.4881 10.0002 14.4881C9.67688 14.4881 9.41478 14.226 9.41478 13.9027V6.09764C9.41478 5.77435 9.67688 5.51227 10.0002 5.51227ZM14.4881 9.21966C14.4881 8.89637 14.226 8.63428 13.9027 8.63428C13.5794 8.63428 13.3173 8.89637 13.3173 9.21966V13.9027C13.3173 14.226 13.5794 14.4881 13.9027 14.4881C14.226 14.4881 14.4881 14.226 14.4881 13.9027V9.21966Z'
				fill='inherit'
				stroke='transparent'
			/>
		</svg>
	);
};

export default Analytics_01_IconSolid;
